module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/esports-slides/esports-slide-list/esports-slide-list.component.scss
// module id = ./libs/atenea-cms-brand/src/esports-slides/esports-slide-list/esports-slide-list.component.scss
// module chunks = main